import VueSwitch from "./VueSwitch";

export default {
    install(Vue, options) {
        Vue.component("VueSwitch", VueSwitch);
    }
}
